"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformClassifierColumns = transformClassifierColumns;
function transformClassifierColumns(params) {
    return {
        name: params.data.name,
        status: params.data.status,
        defaultName: params.data.default?.name,
    };
}
